// @flow

import React, { Component } from 'react';
import classnames from 'classnames';
import $ from 'jquery';
import { Swipeable } from 'react-swipeable';
import Navigation from '../../components/navigation';
import PlannedDowntimeModal from '../../components/modals/planneddowntime';
import NetworkErrorModal from '../../components/modals/networkerror';
import { addBeforeInstallPrompt } from '../../components/swloader';
import Loading from '../../components/modals/loading';
import SystemWarnBanner from '../../components/modals/syswarn';
import SystemDownModal from '../../components/modals/sysdown';
import TermsAndConditionsPage from '../termsandconditionspage';
// eslint-disable-next-line no-unused-vars
import layoutStyles from './layout.scss';
import Footer from '../../components/footer/footer';
import Cookies from '../../components/cookies/cookies';

class Layout extends Component<Props> {
  props: Props;

  constructor() {
    super();
    this.openHamburgerMenu = this.openHamburgerMenu.bind(this);
  }

  componentDidMount() {
    addBeforeInstallPrompt();
    window.addEventListener('hashchange', this.handlePageChange, false);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handlePageChange);
  }

  openHamburgerMenu(event) {
    const { openHamburgerMenu } = this.props;
    openHamburgerMenu();
    if (event.event) {
      event.event.preventDefault();
      event.event.stopPropagation();
    }
  }

  handlePageChange() {
    $(window).scrollTop(0);
  }

  renderLayout() {
    const {
      children,
      showModalBlur,
      authenticating,
      showNavBar,
      user,
    } = this.props;
    return (
      <Swipeable onSwipedRight={this.openHamburgerMenu} delta={75}>
        <Cookies user={user} />
        <div
          className={classnames(
            'full-content-wrapper',
            { 'blur-modal-open': showModalBlur },
            { 'blur-modal-close': showModalBlur === false },
            { 'show-nav-bar': showNavBar },
          )}
        >
          <div className="status-bar-bg" />
          <div className="bg-image" />
          <NetworkErrorModal />
          <PlannedDowntimeModal />
          <TermsAndConditionsPage />
          {user && user.isAuthenticated && user.termsAccepted && <Navigation />}
          {user && user.isAuthenticated && user.termsAccepted && children}
          {user && user.isAuthenticated && <Footer />}
          {authenticating && <Loading />}
        </div>
        <SystemDownModal />
        <SystemWarnBanner />
      </Swipeable>
    );
  }

  render() {
    return this.renderLayout();
  }
}

export default Layout;
